import { useState, useEffect } from 'react';

import { PageTitle, PageTitleSecondary } from '@/components/uiPart';

import { ALL_CUSTOM_COLORS } from '@/utils/chartColor';

import ChartDrawer from '@/container/ChartDrawer';
import PivotTable from '@/container/PivotTable';
import PivotTableDynamic from '@/container/PivotTableDynamic';
import ChartTable from '@/container/ChartTable';
import ChartBar from '@/container/ChartBar';
import ChartGroupedBar from '@/container/ChartGroupedBar';
import ChartStackedColumnBar from '@/container/ChartStackedColumnBar';
import ChartDonut from '@/container/ChartDonut';
import ChartColumnGrouped from '@/container/ChartColumnGrouped';
import ChartBarHorizontal from '@/container/ChartBarHorizontal';
import VegaLite from '@/container/VegaLite';
import ChartStackedHoriBar from '@/container/ChartStackedHoriBar';

import {
  donutChartData,
  chartStackedBarData,
  chartTableData,
  chartBarData,
  chartBarData2,
  ChartGroupedBarData,
  pivotData1,
  ChartStackedHorizontalBarData,
  pivotData3,
  chartStackedColumnBarData,
  ChartStackedHorizontalBarData2
} from '@/utils/constants';
import ChartStackedColumnBarTest from '@/container/ChartStackedColumnBarTest';

const Test = () => {

  const chartData = [
    { "id": "French", "value": 8, label: "French : 8", colorValue: ALL_CUSTOM_COLORS['French'] },
    { "id": "Spanish", "value": 6, label: "Spanish : 6", colorValue: ALL_CUSTOM_COLORS['Spanish'] },
    { "id": "Arabic", "value": 5, label: "Arabic : 5", colorValue: ALL_CUSTOM_COLORS['Arabic'] },
    { "id": "German", "value": 4, label: "German : 4", colorValue: ALL_CUSTOM_COLORS['German'] },
    { "id": "Chinese", "value": 4, label: "Chinese : 4", colorValue: ALL_CUSTOM_COLORS['Chinese'] },
    { "id": "Russian", "value": 4, label: "Russian : 4", colorValue: ALL_CUSTOM_COLORS['Russian'] },
    { "id": "Portuguese", "value": 3, label: "Portuguese : 3", colorValue: ALL_CUSTOM_COLORS['Portuguese'] },
    { "id": "Japanese", "value": 2, label: "Japanese : 2", colorValue: ALL_CUSTOM_COLORS['Japanese'] },
    { "id": "Italian", "value": 2, label: "Italian : 2", colorValue: ALL_CUSTOM_COLORS['Italian'] },
    { "id": "English", "value": 1, label: "English : 1", colorValue: ALL_CUSTOM_COLORS['English'] },
  ]

  return (
    <div className="flex flex-1 h-max-full flex-col" >

      <PageTitle title="View Charts" />
      <PageTitleSecondary title="Interactive data visualizations and analytics" />

      {/* <ChartDrawer selectedKpi={11} /> */}


      <h5>Chart Stacked Column Bar</h5>
      <div className=" w-[650px] border border-red-100 ">
        <ChartStackedColumnBarTest item={chartStackedColumnBarData} />
      </div>
      {/* <h5>Chart Column Grouped</h5>
      <ChartColumnGrouped item={{data: ChartGroupedBarData}} /> */}

      {/* <h5>Chart Bar</h5>
      <div className=" w-[700px] border border-red-100 ">
        <ChartBar item={chartBarData2} />
      </div> */}

      {/* <h5>Chart Stacked Horizontal Bar</h5>
      <ChartStackedHoriBar item={ChartStackedHorizontalBarData2} /> */}

      {/* <h5>Vega Lite</h5>
      <VegaLite item={ChartStackedHorizontalBarData2} /> */}

      {/* <h5>Chart Grouped Horizontal Bar</h5>
      <div className=" w-[600px] border border-red-100 ">
        <ChartGroupedBar item={{ data: ChartGroupedBarData, legend_title: '' }} />
      </div> */}

      {/* <h5>Chart Bar Horizontal</h5>
      <ChartBarHorizontal item={{data: chartBarData, legend_title: ''}} /> */}

      {/* <h5>Chart Donut</h5>
      <ChartDonut chartData={donutChartData} /> */}

      {/* <h5>Chart Table</h5>
      <ChartTable tableData={[chartTableData]} /> */}

      {/* <h5>Pivot Table</h5>
      <PivotTable data={pivotData1.data} header={pivotData1.headers} /> */}

      {/* <h5>Pivot Table Dynamic</h5>
      <PivotTableDynamic items={pivotData3} /> */}

    </div>
  );
};

export default Test;